import axios from "axios";
import UidEmailRoleMatch from "../../../../constants/uidEmailRoleMatch";

export const getKeyPerson = (keyPersonId: number, sessionId: string | null) => {
  const UidEmailRole = UidEmailRoleMatch();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/one/tradexwbench.customer_key_person/${keyPersonId}`,
      {
        params: {
          ...UidEmailRole,
          filter: `[]`,
          query:
            "{customer_id,key_person_type_ids,designation,if_others,partnership_percentage,first_name,middle_name,last_name,related_person_type,father_spouse_name,mother_name,gender,date_of_birth,ownership_percentage,tax_id,employee_id,passport_number,passport_expiry_date,nationality_country_id,tax_residency_country_id,email,ckycno,is_politically_exposed,is_minor,is_beneficial_owner,is_admin,guardian_relation,guardian_name,key_person_address_line_1,key_person_address_line_2,key_person_address_city,key_person_address_district,key_person_address_state,key_person_address_pincode,key_person_address_country_id,phone_country_code,phone,din,customer_key_person_document_ids, if_others,  api_designation_flag,api_first_name_flag,api_last_name_flag, api_date_of_birth_flag,api_gender_flag, api_mother_name_flag,  nationality_country_id_flag, api_tax_id_flag,api_din_flag, api_district_flag, api_state_flag,api_country_flag, api_city_flag,api_email_flag, api_if_others_flag,is_current_address, key_person_current_address_line_1, key_person_current_address_line_2, key_person_current_address_pincode,key_person_current_address_district,key_person_current_address_state,key_person_current_address_country_id, key_person_current_address_city}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
